module.exports = __webpack_public_path__ + "static/media/BubblesBanner.e40db723.png";